import React, { useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance as axios } from '../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { StandardsList } from './StandardsList';

export const StandardsGate = ({ open, onAccepted }) => {
  const [agree, setAgree] = useState(false);
  const [saving, setSaving] = useState(false);
  const accept = async () => {
    setSaving(true);
    try {
      await axios.post('/api/directory/my-profile/accept-standards');
      toast.success('Thank you for accepting the Standards');
      onAccepted();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not save. Please try again.');
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto [&>button]:hidden" data-testid="standards-gate">
        <DialogHeader>
          <DialogTitle>Professional Participation Standards</DialogTitle>
          <DialogDescription>Please review and accept LFF's updated standards. Your listing stays hidden from families until you accept.</DialogDescription>
        </DialogHeader>
        <StandardsList />
        <label className="flex items-start gap-2 text-sm mt-4">
          <input type="checkbox" checked={agree} onChange={e => setAgree(e.target.checked)} className="mt-1" data-testid="standards-gate-checkbox" />
          <span>I have read and agree to follow these standards.</span>
        </label>
        <div>
          <button onClick={accept} disabled={!agree || saving}
            className="w-full mt-4 px-4 py-3 bg-blue-600 text-white rounded-lg font-semibold disabled:opacity-50" data-testid="standards-gate-accept-btn">
            {saving ? 'Saving…' : 'Accept Standards'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const NOTICES = {
  info_requested: ['bg-amber-50 border-amber-300 text-amber-900', 'More information needed', 'Update your profile below with the requested details. Saving sends it back to LFF for review.'],
  suspended: ['bg-red-50 border-red-300 text-red-900', 'Your listing is suspended', 'Families cannot see your listing while LFF reviews it.'],
  rejected: ['bg-gray-100 border-gray-300 text-gray-800', 'Application not approved', 'Contact Legacy Forge Family if you have questions.'],
};

export const ProStatusNotice = ({ profile }) => {
  const n = NOTICES[profile?.status];
  if (!n) return null;
  return (
    <div className={`border rounded-lg p-4 mb-6 ${n[0]}`} data-testid="pro-status-notice">
      <p className="font-semibold">{n[1]}</p>
      {profile.status_reason && <p className="text-sm mt-1">LFF note: {profile.status_reason}</p>}
      <p className="text-sm mt-1">{n[2]}</p>
    </div>
  );
};
